import { create } from 'zustand';

type ActivityTabStore = {
  forceMove: boolean;
  id: number | null;
  forceOpenActivity: (id: number) => void;
  clearForce: () => void;
};

export const useForceOpenActivityStore = create<ActivityTabStore>((set) => ({
  forceMove: false,
  id: null,
  forceOpenActivity(id) {
    set({ id, forceMove: true });
  },
  clearForce() {
    set({ forceMove: false });
  }
}));
